import { combineReducers } from "redux"
import { activation } from './companyActivationReducer'

const activationReducers = combineReducers({
    activation,
})

export default activationReducers